function Loading() {
  return (
    <div className="c-loader">
      <div className="c-loader__inner">Lädt...</div>
    </div>
  );
}

export default Loading;
